<div id="wrapper" class="bg-fondo">
    <app-header></app-header>
    <app-sidebar></app-sidebar>
    <div class="content-page bg-fondo">
        <div class="content">
            <!-- Start Content-->

            <div class="container-fluid">
                <div></div>
                <!-- En cada pagina/aplicacion se debe incluir lo siguiente: 
                <app-pagetitle title="Titulo pagina" [breadcrumbItems]="array con arbol de migas de pan"></app-pagetitle>-->
                <div class="container-fluid card" id="">
                    <div class="row card-body">
                        <div class="col col-8 col-md-8 col-lg-8 col-xs-12 col-sm-12">
                            <small>
                                Los datos mostrados corresponden a: <strong>{{nombreUnidad}}</strong> del nivel <strong>{{nivelActual}}</strong>
                            </small>
                        </div>

                        <div class="col col-4 col-md-4 col-lg-4 col-xs-12 col-sm-12">
                            <form [formGroup]="formSelectAnioLayout">
                                <div class="form-group row mb-1 ">
                                    <div class="col col-md-4 text-md-right ">
                                        <label for="idSprAnio" class="col-form-label text-md-right"><b>Plan Anual:</b>
                                        </label>
                                    </div>
                                    <div class="col-4 col-md-8 ">
                                        <select class="form-select " id="idSprAnio2" style="white-space:pre-wrap;" formControlName="idSprAnioSelectedLayout" (change)="changeAnioSelectedLayout($event)">
                                            <option *ngFor="let row of dataAniosPlanInst" value={{row.idSprPlanAnio}}>
                                                {{row.anio}} 
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>

                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>